export const THINGS_GROUP_PAGE_NS = 'pages/ThingsGroupPage';

export const i18n = {
  en: {
    titles: {
      drafts: 'Drafts',
      draftAssetType: 'Draft asset type',
      addFirstAssetType: "Let's add your first asset",
    },
    descriptions: {
      checkKnowledgeBase: 'Check our Knowledge Base to learn more',
      createAssetType:
        'Create digital twins of your assets and start transforming how the world works.',
    },
    buttons: {
      buildNewAssetType: 'Build new asset type',
      importAssets: 'Import assets',
    },
    actions: {
      manage: 'Manage asset type',
      edit: 'Edit asset type',
      continueEditing: 'Continue editing',
      showVersion: 'Show asset type version',
    },
    totalWorkItems: {
      totalItems: 'items',
    },
  },
};
